import { render, staticRenderFns } from "./AppChatSignatureRequestPreview.vue?vue&type=template&id=6fad470d&scoped=true"
import script from "./AppChatSignatureRequestPreview.vue?vue&type=script&lang=js"
export * from "./AppChatSignatureRequestPreview.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fad470d",
  null
  
)

export default component.exports